import { Box, Stack } from '@eneco/sparky';
import { SpinnerIcon } from '@eneco/sparky/icons';

export const LoadingListSpinner = () => {
  return (
    <Box paddingY={2}>
      <Stack alignX={'center'}>
        <SpinnerIcon />
      </Stack>
    </Box>
  );
};
